export default "__VITE_ASSET__D4HZsdK5__"